import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import util from '@/libs/util';
import changeOrderDialog from './changeOrderDialog';
export default {
  components: {
    changeOrderDialog: changeOrderDialog
  },
  mounted: function mounted() {
    this.CREATORID = JSON.parse(util.cookies.get('userInfo')).USER_NAME;
  },
  data: function data() {
    return {
      formData: {
        ID: null,
        DELIVERY_NO: null,
        // 送货单号
        DESCRIPTION: null,
        // 备注
        CREATETIME: null,
        // 创建日期
        VENDOR_CODE: null,
        // 供应商代码
        VENDOR_NAME: null // 供应商名称

      },
      // mode:'show',
      vendorOptions: [],
      selectLoading: false,
      CREATORID: null,
      isShowChangeVendorDialog: false,
      // 显示选择供应商dialog
      submitObj: null,
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      formDataRules: {
        DELIVERY_NO: [{
          required: true,
          message: '请选择送货单'
        }]
      },
      // printUrl: process.env.VUE_APP_PrintURL,
      templateID: null,
      isDisabled: true,
      isShowChangeOrderDialog: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/OuterBoxLabelManagement', ['setOrderStatu'])), {}, {
    valiData: function valiData() {
      if (this.formData.DELIVERY_NO === null) {
        this.$message.warning('请选择送货单');
        return false;
      } else {
        return true;
      }
    },
    // 打开选择送货单dialog
    ShowChangeOrderDialog: function ShowChangeOrderDialog() {
      var _this = this;

      this.isShowChangeOrderDialog = true;
      this.$nextTick(function () {
        _this.$refs.changeOrderDialog.getOrderlist();
      });
    },
    // 明细dialog确定按钮回调
    cbDialogSubmit: function cbDialogSubmit(selectRecords) {
      // console.log('selectRecords',selectRecords);
      this.setData(selectRecords);
      this.$emit('cbSelectedID', selectRecords.ID);
    },
    // 明细dialog关闭
    closeChangeOrderDialog: function closeChangeOrderDialog() {
      this.isShowChangeOrderDialog = false;
    },
    getData: function getData() {
      return this.formData;
    },
    // 设置数据
    setData: function setData(data) {
      this.formData.DELIVERY_NO = data.DELIVERY_NO;
      this.formData.CREATORID = data.CREATORID;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.DELIVERY_DATE = util.formatTime.transCommDate(data.DELIVERY_DATE);
      this.formData.VENDOR_NAME = data.VENDOR_NAME;
      this.formData.ARRIVAL_DATE = util.formatTime.transCommDate(data.ARRIVAL_DATE);
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.CREATETIME = data.CREATETIME;
    } // 分割线 ----------------------------------------------------------------------------

  }),
  watch: {
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        var _this2 = this;

        // console.log('表头 单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'orderShow') {
          this.isDisabled = true;
        } else if (nawValue === 'listShow') {
          this.$nextTick(function () {
            _this2.$refs.formData.resetFields();
          });

          for (var key in this.formData) {
            this.formData[key] = null;
          }
        } else if (nawValue === 'editOrder') {
          this.isDisabled = false;
        } else {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState'])),
  beforeDestroy: function beforeDestroy() {}
};